import { apiGet, systemRequestConfig } from '@api/api.utils'

import { IResponseStorageInfo, IResponseVarWwwDirectories } from './api.types'


const route = '/systems'

export const getStorageInfo = (signal?: AbortSignal, isSystemRequest: boolean = false): Promise<IResponseStorageInfo> => {
    const config = {signal}
    return apiGet<IResponseStorageInfo>(`${route}/getStorageInfo`, isSystemRequest ? systemRequestConfig(config) : config)
}

export const getVarWwwDirectories = (refresh: boolean = false, signal?: AbortSignal): Promise<IResponseVarWwwDirectories> =>
    apiGet<IResponseVarWwwDirectories>(`${route}/getVarWwwDirectories`, {
        signal,
        params: refresh ? {refresh: 1} : undefined,
    })

export const getYaskillVarWwwDirectories = (
    refresh: boolean = false,
    signal?: AbortSignal,
): Promise<IResponseVarWwwDirectories> =>
    apiGet<IResponseVarWwwDirectories>(`${route}/getYaskillVarWwwDirectories`, {
        signal,
        params: refresh ? {refresh: 1} : undefined,
    })